export const LISTENING_DIALOG_MODES = {
  LIST: "LIST",
  CREATE: "CREATE",
  EDIT: "EDIT",
  DETAILS: "DETAILS",
  COMPONENTS: "COMPONENTS",
};

export const LISTENING_FORM_STEPS = {
  DECLARATION: 0,
  VALUES: 1,
};
